// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { LogLevel } from '@wellro/utils';

export const environment = {
  production: false,
  whatsAppNumber: '+94705302302',
  firebase: {
    apiKey: 'AIzaSyAeyUrVWNWRe8LVIljY4j7PlmJDo-wWdNg',
    authDomain: 'wellro-dev.firebaseapp.com',
    projectId: 'wellro-dev',
    storageBucket: 'wellro-dev.appspot.com',
    messagingSenderId: '149375594051',
    appId: '1:149375594051:web:3ea9dc76c6084e99556ef6',
    measurementId: 'G-WCWEPKLKZ0',
  },
  sentry: {
    dsn:
      'https://f2a5d616b5204c70bb4a8e66f3c62bd3@o4504682974740480.ingest.sentry.io/4504693759279104',
    env: 'development',
  },
  tenantId: 'customer-t5oub',
  logLevel: LogLevel.DEBUG,
  hostUrl: 'https://dev.wellro.life',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
